export const MIN_CHARS_FOR_SENDING_REQUEST = 4;
export const MIN_CHARS_FOR_SENDING_REQUEST_BATTERY = 3;
